module.exports = require("vue-multiselect");